import axios from 'axios';

const authBaseUrl = process.env.REACT_APP_BASE_URL;

const login = async (username, password) => {
    try {
        const response = await axios.post(`${authBaseUrl}/api/auth/login`, {
            username,
            password,
        });
        return response.data;
    } catch (error) {
        throw error.response || error;
    }
};

const register = async (username, password, email) => {
    try {
        const response = await axios.post(`${authBaseUrl}/api/auth/register`, {
            username,
            password,
            email,
        });
        return response.data;
    } catch (error) {
        throw error.response || error;
    }
};

const AuthService = { login, register };

export default AuthService;
